
<div class="organization-container">
  <div class="incident-search-wrapper">
    <div>
      <span style="font-weight: 600; font-size: 1.1rem; color: #fff; flex: 1;">
        Organization ({{ getNumberOfOrganisationFilter()}})
      </span>

    </div>
    @if (organizations.length > 1) {
      <div style="margin-top: 8px; position: relative;" class="d-flex mb-1 gap-2">
        <input class="listSearch form-control" type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearch($event)"
          placeholder="Search Organization" autofocus />
          <i class="fa fa-search search-icon-wrapper"></i>
        </div>
      }
    </div>


    <div class="custom-scroll">
      <table class="table table-striped table-hover custom-table">
        <tbody>
          @for (org of filteredOrganizations; track org) {
            <tr class="tdinserted" (click)="onOrganizationSelect(org)">
              <td class="py-1">{{ org.name }}</td>
              <td class="py-1 text-end">
                <i class="bi bi-info-circle-fill" (click)="showOrganizationInfo(org, $event)"></i>
              </td>
              <td class="py-1 text-end">
                <i class="bi bi-envelope-fill" (click)="sendMessage(org, $event)"></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>